import Translate from '~/client/shared/i18n/Translate';

type Props = {
  translateId?: string;
};

const PageTitle: FC<Props> = ({ translateId, children }) => (
  <h1 className="z-2 self-end text-moon-24 text-bulma">
    {translateId ? <Translate id={translateId} /> : children}
  </h1>
);

export default PageTitle;
